module.exports = __webpack_public_path__ + "img/gunship.8a08781b.webp";